import checkIfGuestHasRegister from './checkIfGuestHasRegister';
import uploadFileToS3 from './uploadFileToS3';
import validateFace from './validateFace';

export default {
  checkIfGuestHasRegister,
  uploadFileToS3,
  validateFace,
}
